import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { AuthService } from '../../../services/auth.service';
import { CtaAnimation } from './dynamic-cta.animation.model';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-dynamic-cta',
	templateUrl: './dynamic-cta.component.html',
	styleUrls: ['./dynamic-cta.component.scss']
})
export class DynamicCTAComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('dynamicCtaForm', { static: true }) dynamicCtaForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	submitted: Boolean = false;
	isPreviewPromiseCompleted: Boolean = false;
	previewPromiseSubscription: Subscription;
	ctaAnimations: Array<CtaAnimation>;
	userAnimations: Array<CtaAnimation>;
	selectedAnimation: CtaAnimation;
	dynamicCtaFormSubscription: Subscription;
	componentDataSubscription: Subscription;
	linkFocus;
	assetDirectory = `${environment.dmAssetsDomain}/creator/dynamic_cta/`;
	isAdmin;

	constructor(private auth: AuthService, private cs: ComponentService) {
		this.ctaAnimations = [
			new CtaAnimation({
				id: 0,
				animation_type: '',
				animation_url: '',
				name: 'Lightning'
			}),
			new CtaAnimation({
				id: 1,
				animation_type: 'cta',
				animation_url: 'leaves.gif',
				name: 'Leaves'
			}),
			new CtaAnimation({
				id: 2,
				animation_type: 'cta',
				animation_url: 'snow.gif',
				name: 'Snow'
			}),
			new CtaAnimation({
				id: 3,
				animation_type: 'cta',
				animation_url: 'hearts.gif',
				name: 'Hearts'
			}),
			new CtaAnimation({
				id: 4,
				animation_type: 'cta',
				animation_url: 'stars.gif',
				name: 'Stars'
			}),
			new CtaAnimation({
				id: 5,
				animation_type: 'custom',
				animation_url: '',
				animation_custom_url: '',
				name: 'Custom'
			})
		];
	}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.previewPromiseSubscription = this.cs.isPreviewPromiseCompleted.subscribe((res) => (this.isPreviewPromiseCompleted = res));
		this.dynamicCtaFormSubscription = this.dynamicCtaForm.valueChanges
			.pipe(
				tap(() => {
					this.cs.updateDisabledSave(
						(this.dynamicCtaForm.dirty && this.dynamicCtaForm.invalid) || this.nameField.editComponentName
					);
					this.submitted = false;
				}),
				filter((form) => Boolean(this.dynamicCtaForm.dirty && this.dynamicCtaForm.valid && this.isPreviewPromiseCompleted)),
				debounceTime(2000),
				tap(() => (this.submitted = true))
			)
			.subscribe();

		if (this.componentData.config.version >= 2) {
			this.ctaAnimations.forEach((item, index) => {
				if (item.name == 'Lightning') {
					this.ctaAnimations[index].animation_type = 'cta';
					this.ctaAnimations[index].animation_url = 'lightning';
				} else {
					this.ctaAnimations[index].animation_url =
						item.animation_type == 'cta'
							? `${this.assetDirectory}${this.ctaAnimations[index].animation_url}`
							: this.ctaAnimations[index].animation_url;
				}
			});
			this.userAnimations = this.isAdmin
				? [...this.ctaAnimations]
				: this.ctaAnimations.filter((animation) => animation.animation_type !== 'custom');
			this.setSelectedAnimation();
		} else {
			this.componentDataSubscription = this.cs.componentData.pipe(filter((data) => data !== null)).subscribe((newData: any) => {
				if (
					this.componentData.config.animation_type &&
					this.componentData.config.animation_type.toUpperCase() === 'CUSTOM' &&
					this.componentData.config.animation_custom_url &&
					this.componentData.config.animation_custom_url.length
				) {
					this.userAnimations = this.ctaAnimations;
					this.setSelectedAnimation();
				} else {
					this.userAnimations = this.ctaAnimations.filter((animation) => animation.animation_type !== 'custom');
					this.setSelectedAnimation();
				}
			});
		}
	}

	ngOnDestroy() {
		this.dynamicCtaFormSubscription.unsubscribe();
		if (this.componentDataSubscription) {
			this.componentDataSubscription.unsubscribe();
		}
		this.previewPromiseSubscription.unsubscribe();
	}

	renderWidget(): void {
		this.cs.updateComponentData(this.componentData);
		this.cs.updatePreviewData();
	}

	setSelectedAnimation() {
		const defaultAnimation: CtaAnimation = this.ctaAnimations[0];

		if (this.componentData && this.componentData.config) {
			const animationType = this.componentData.config.animation_type && this.componentData.config.animation_type.toUpperCase();

			switch (animationType) {
				case 'CUSTOM': {
					this.selectedAnimation = this.ctaAnimations[this.ctaAnimations.length - 1];
					this.selectedAnimation.animation_url = this.componentData.config.animation_url;
					this.selectedAnimation.animation_custom_url = this.componentData.config.animation_custom_url;
					break;
				}

				case 'CTA': {
					const userAnimation = this.ctaAnimations.filter(
						(animation) => animation.animation_url === this.componentData.config.animation_url
					);
					if (userAnimation.length) this.selectedAnimation = userAnimation[0];
					break;
				}

				default: {
					this.selectedAnimation = defaultAnimation;
					break;
				}
			}
		}
	}

	onAnimationChange(animation: CtaAnimation): void {
		this.componentData.config.animation_type = animation.animation_type;
		this.componentData.config.animation_url = animation.animation_url;
	}
}
